import AddRocketSeries from "../../components/addRocketSeries";
import * as Styled from "./styled";
import Sidemenu from "../../components/sidemenu";

const AddTraining = () => {
  return (
    <Styled.MainDiv>
      <Sidemenu />
      <Styled.ColumnDiv>
        <AddRocketSeries />
      </Styled.ColumnDiv>
    </Styled.MainDiv>
  );
};

export default AddTraining;
